<template>
  <overlay-scrollbars id="katalog-scroll-container" :options="{ className: 'content white custom-scrollbar os-theme-dark', scrollbars: { visibility: 'auto', autoHide: 'leave', autoHideDelay: 400, dragScrolling: true, clickScrolling: false, touchSupport: true, snapHandle: false } }">
    <TheLoader :active="loading || updating" :update="updating"/>

    <section class="content large white">
      <table id="besikt-table" class="large fixed sortable visible " style="width: 100%">
      <thead>
        <tr>
          <th v-bind:class="[params && params.sort === 'Objekt.Katalognr' ? sortClass : '']" @click="sortBy('Objekt.Katalognr')">
            Katalognr.
            <span id="sorttable_sortrevind" v-if="params && params.sort === 'Objekt.Katalognr' && params.direction === 'DESC'">&nbsp;</span>
            <span id="sorttable_sortfwdind" v-if="params && params.sort === 'Objekt.Katalognr' && params.direction === 'ASC'">&nbsp;</span>
          </th>
          <th v-bind:class="[params && params.sort === 'Objekt.Kunstner.Navn' ? sortClass : '']" @click="sortBy('Objekt.Kunstner.Navn')">
            Kunstner
            <span id="sorttable_sortrevind" v-if="params && params.sort === 'Objekt.Kunstner.Navn' && params.direction === 'DESC'">&nbsp;</span>
            <span id="sorttable_sortfwdind" v-if="params && params.sort === 'Objekt.Kunstner.Navn' && params.direction === 'ASC'">&nbsp;</span>
          </th>
          <th>Tittel</th>
          <th style="min-width: 8rem;" v-bind:class="['align-right show-for-large', params && params.sort === 'Besikt.Registrert_dato' ? sortClass : '']" @click="sortBy('Besikt.Registrert_dato')">
            Opprettet
            <span id="sorttable_sortrevind" v-if="params && params.sort === 'Besikt.Registrert_dato' && params.direction === 'DESC'">&nbsp;</span>
            <span id="sorttable_sortfwdind" v-if="params && params.sort === 'Besikt.Registrert_dato' && params.direction === 'ASC'">&nbsp;</span>
          </th>
          <th>Mottaker</th>
          <th>Email</th>
          <th>Telefon</th>
          <th class="align-right show-for-large">Sendt</th>
        </tr>
      </thead>
      <tbody v-if="items.length < 1">
        <tr>
          <td colspan="8"><em>Søk ved hjelp av auksjonskode i søkefeltet...</em></td>
        </tr>
      </tbody>
      <tbody>
        <tr v-for="(item, index) in parsedItems" v-bind:key="'main-' + index + '-' + item.Objektid">
          <template v-if="!item.hide">
            <td>{{ item.objekt.Katalognr || '-'}}</td>
            <td v-if="item.objekt.kunstner">
              {{ item.objekt.kunstner.Navn }}
            </td>
            <td v-else-if="item.objekt.Kunstner">
              {{ item.objekt.Kunstner }}
            </td>
            <td v-else>-</td>
            <td>
              {{ item.objekt.Katalogtekst1  | truncate(100) }}
            </td>
            <td class="align-right show-for-large">
              {{ item.Registrert_dato | avantidatetime }}
              <span class="opacity-60" style="font-size: 0.7rem;" v-if="item.bruker">
                <br>{{ item.bruker.full_name}}
              </span>
            </td>
          </template>
          <template v-else>
            <td>"</td>
            <td>"</td>
            <td>"</td>
            <td class="align-right show-for-large">"</td>
          </template>

          <template v-if="item.parsed_logg">
            <td v-if="item.parsed_logg.kunde && item.parsed_logg.kunde.Bedrift">{{ item.parsed_logg.kunde.FirmaNavn || (item.parsed_logg.kunde.full_name || '-') }}</td>
            <td v-else-if="item.parsed_logg.kunde">{{ item.parsed_logg.kunde.full_name || '-' }}</td>
            <td v-else>-</td>
            <td>{{ item.parsed_logg.toEmail }}</td>
            <td>{{ item.parsed_logg.kunde ? (item.parsed_logg.kunde.full_phone || '-') : '-' }}</td>
            <td class="align-right show-for-large">
              {{ item.parsed_logg.createdAt | avantidatetime }}
              <span class="opacity-60" style="font-size: 0.7rem;">
                <br>{{ item.parsed_logg.bruker ? item.parsed_logg.bruker.full_name : 'Ukjent' }}
              </span>
            </td>
          </template>
          <template v-else>
            <td colspan="4" class="align-right"><em class="opacity-60">Ikke sendt...</em></td>
          </template>
        </tr>
      </tbody>
      </table>
      <br>
      <br>
      <div class="pagination-container"  v-if="pages > 1" style="margin-top: -1rem;">
        <paginate v-model="params.page"
          :page-count="pages"
          :page-range="11"
          :click-handler="setPage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
          >
        </paginate>
      </div>
    </section>
  </overlay-scrollbars>
</template>

<script>
import ObjektService from '@/services/ObjektService'
import fileDownload from 'js-file-download'
import moment from 'moment'
import Papa from 'papaparse'
import bus from '@/plugins/event-bus'

export default {
  name: 'BesiktigelseList',
  data () {
    return {
      loading: false,
      updating: false,
      items: [],
      pages: 1,
      params: {
        page: 1,
        code: null,
        sort: 'Objekt.Katalognr',
        direction: 'ASC',
        limit: 100
      },
      selected: []
    }
  },
  created () {
    bus.$off('reload-besiktigelselist')
    bus.$off('export-besiktigelselist')
  },
  mounted () {
    bus.$on('reload-besiktigelselist', (data) => this.resetAndReload(data))
    bus.$on('export-besiktigelselist', (data) => this.exportToExcel(data))
  },
  activated () {
    this.loading = false

    this.setDefaultParams()
    this.$emit('onSubmitStatusChange', 'submittable')
  },
  computed: {
    sortClass: function () {
      return 'sorttable_sorted' + (this.params.direction === 'DESC' ? '_reverse' : '')
    },
    parsedItems: function () {
      const retval = []

      if (!this.items || this.items.length < 1) {
        return []
      }

      this.items.forEach(i => {
        if (!i.email_logg || i.email_logg.length < 1) {
          i.parsed_logg = null
          i.hide = false
          retval.push(i)
        } else {
          let c = 0

          i.email_logg.forEach(l => {
            let t = this._.cloneDeep(i)

            if (++c > 1) {
              t.hide = true
            } else {
              t.hide = false
            }

            t.parsed_logg = l

            retval.push(t)
          })
        }
      })

      return retval
    }
  },
  methods: {
    sortBy: function (sortKey) {
      if (!this.params) {
        return
      }

      if (this.params.sort === sortKey) {
        this.params.direction = this.params.direction === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.params.sort = sortKey
        this.params.direction = 'ASC'
      }

      this.reload()
    },
    itemLeveringsAdresse: function (item) {
      if (!item.kundeadresse) {
        return null
      }

      return this._.find(item.kundeadresse, ['Type', 'levering']) || null
    },
    setDefaultParams: function () {
      this.params = {
        page: 1,
        code: null,
        sort: 'Objekt.Katalognr',
        direction: 'ASC',
        limit: 100
      }
    },
    reload: function () {
      this.updating = true

      this.$emit('onSubmitStatusChange', 'loading')

      this.fetch()
    },
    resetAndReload: function (data) {
      this.updating = true

      this.$emit('onSubmitStatusChange', 'loading')
      this.setDefaultParams()

      if (data) {
        this.$set(this.params, 'code', data)
      } else {
        this.$set(this.params, 'code', null)
      }

      this.fetch()
    },
    setPage: function (page) {
      let vm = this

      window.jQuery('.os-viewport', window.jQuery('#katalog-scroll-container')).animate({
        scrollTop: 0
      }, 200, function () {
        vm.updating = true
        vm.$emit('onSubmitStatusChange', 'loading')
        vm.fetch()
      })
    },
    exportToExcel: function (code) {
      this.$emit('onSubmitStatusChange', 'exporting')

      if (code) {
        this.$set(this.params, 'code', code)
      } else {
        this.$set(this.params, 'code', null)
      }

      const params = this._.cloneDeep(this.params || {})
      params.export = 1

      ObjektService.getBesiktWithLog(params)
        .then((response) => {
          this.makeExcel(response.data)
        })
        .catch(() => {
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    },
    makeExcel: function (indata) {
      const data = []

      if (!indata || indata.length < 1) {
        return []
      }

      indata.forEach(i => {
        if (!i.email_logg || i.email_logg.length < 1) {
          i.parsed_logg = null
          i.hide = false
          data.push(i)
        } else {
          let c = 0

          i.email_logg.forEach(l => {
            let t = this._.cloneDeep(i)

            if (++c > 1) {
              t.hide = true
            } else {
              t.hide = false
            }

            t.parsed_logg = l

            data.push(t)
          })
        }
      })

      const xarray = []
      const fields = [
        'Katalog nr.',
        'Kunstner',
        'Tittel',
        'Opprettet dato',
        'Opprettet av',
        '',
        'Mottaker',
        'Email',
        'Telefon',
        'Sendt dato',
        'Sendt av'
      ]

      // Note: wrap value in ="VALUE" to keep leading zeroes.
      xarray.push(fields)
      data.forEach(item => {
        const kunstner = item.objekt.kunstner
          ? item.objekt.kunstner.Navn
          : item.Kunstner || '-'

        let name = ''
        let phone = ''
        let email = ''
        let createdAt = this.$options.filters.avantidatetime(item.Registrert_dato)
        let createdBy = item.bruker ? item.bruker.full_name : '-'

        let sentAt = ''
        let sentBy = ''

        if (item.parsed_logg) {
          sentAt = this.$options.filters.avantidatetime(item.parsed_logg.createdAt)
          sentBy = item.parsed_logg.bruker ? item.parsed_logg.bruker.full_name : '-'

          email = item.parsed_logg.toEmail

          if (item.parsed_logg.kunde) {
            name = item.parsed_logg.kunde.Bedrift
              ? item.parsed_logg.kunde.FirmaNavn || (item.parsed_logg.kunde.full_name || '-')
              : item.parsed_logg.kunde.full_name || '-'

            phone = item.parsed_logg.kunde.full_phone
          }
        }

        const temp = [
          '="' + (item.objekt.Katalognr || '-') + '"',
          '="' + (kunstner) + '"',
          '="' + (item.objekt.Katalogtekst1 || '-') + '"',
          '="' + (createdAt || '-') + '"',
          '="' + (createdBy || '-') + '"',
          '',
          '="' + (name || '-') + '"',
          '="' + (email || '-') + '"',
          '="' + (phone || '-') + '"',
          '="' + (sentAt || '-') + '"',
          '="' + (sentBy || '-') + '"'
        ]

        xarray.push(temp)
      })

      // Finally make csv and force download...
      const csv = '\ufeff' + Papa.unparse(xarray, { delimiter: ';' })
      const blob = new Blob([csv], {
        type: 'application/csvcharset=utf-8'
      })

      fileDownload(blob, 'besikt-' + moment().format('DDMMYYHms') + '.csv')
    },
    fetch: function () {
      this.selected = []

      ObjektService.getBesiktWithLog(this.params)
        .then(response => {
          this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
          this.items = response.data
        })
        .catch((error) => {
          console.log('Error....')
          console.log(error)
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste inn liste')
        })
        .then(() => {
          this.loading = false
          this.updating = false
          this.$emit('onSubmitStatusChange', 'submittable')
        })
    }
  }
}
</script>
<style scoped>
  #besikt-table td {
    padding-top: 0.25rem;
    vertical-align: top;
  }

  .email-log-table {
    width: 100%;
    margin: 0;
    padding: 0;
  }

  #besikt-table .email-log-table tr,
  #besikt-table .email-log-table td {
    margin: 0;
    padding: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/Reports/BesiktigelseList.vue